<div [popover]="dpPopover"
     triggers=""
     #pop="bs-popover"
     containerClass="datepicker-popover"
     [container]="appendTo"
     [outsideClick]="true"
     [adaptivePosition]="true"
     placement="bottom left">
    <div class="input-group datepicker-input-group">
        <button type="button"
                tabindex="-1"
                class="input-group-addon"
                [ngClass]="{'is-invalid': isInvalid, 'disabled': disabled}"
                [disabled]="disabled"
                aria-label="Open date picker"
                (mousedown)="$event.preventDefault()"
                (click)="showPicker(pop)"
                (keydown)="onKeydown()">
            <i class="fa fa-calendar"></i>
        </button>
        <input [attr.id]="inputId"
               type="text"
               [placeholder]="placeholder"
               class="datepicker-input form-control mm-default-text"
               autocomplete="off"
               [mmInputMask]="datePickerInputMask"
               [mmShortHandParser]="allowShortcuts"
               [inputMaskValidationDisabled]="true"
               [disabled]="disabled"
               [readonly]="readonly"
               [ngModel]="inputModel"
               [ngClass]="{'is-invalid': isInvalid}"
               [ngModelOptions]="{ standalone: true }"
               (ngModelChange)="onInputModelChange($event)"
               (updateDate)="updateDate($event)"
               (click)="showPicker(pop)"
               (keyup.esc)="hidePicker(pop)"
               (keydown.enter)="hidePicker(pop)"
               (keydown.tab)="hidePicker(pop)"
               (blur)="onInputBlur()" />
    </div>
</div>
<ng-template #dpPopover>
    <bs-datepicker-inline [bsConfig]="datepickerConfig" [bsValue]="pickerModel" (bsValueChange)="onPickerChange($event, pop)"></bs-datepicker-inline>
</ng-template>
